import React from 'react'

const EditAd = () => {
  return (
    <div>EditAd</div>
  )
}

export default EditAd